const DASHBOARD_ENABLED_PAGES = ['cart', 'checkout'];

const canUseDashboardMode = (pathname) => {
  for (const page of DASHBOARD_ENABLED_PAGES) {
    if (pathname.includes(page)) return true;
  }
  return false;
};

export { canUseDashboardMode };
